export const COMMON_TIMEZONES = [
	"America/Los_Angeles",
	"America/Denver",
	"America/Chicago",
	"America/New_York",
	"America/Toronto",
	"Europe/London",
	"Europe/Berlin",
	"Europe/Paris",
	"Asia/Singapore",
	"Asia/Tokyo",
	"Australia/Sydney",
];

export function browserTimezone(): string {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
	} catch {
		return "UTC";
	}
}

export function tzAbbrev(tz: string): string {
	try {
		const parts = new Intl.DateTimeFormat("en-US", {
			timeZone: tz,
			timeZoneName: "short",
		}).formatToParts(new Date());
		return parts.find((p) => p.type === "timeZoneName")?.value ?? "";
	} catch {
		return "";
	}
}

export function prettyTz(tz: string): string {
	const city = tz.split("/").pop()?.replace(/_/g, " ") ?? tz;
	let abbrev = "";
	try {
		const parts = new Intl.DateTimeFormat("en-US", {
			timeZone: tz,
			timeZoneName: "short",
		}).formatToParts(new Date());
		abbrev = parts.find((p) => p.type === "timeZoneName")?.value ?? "";
	} catch {
		/* noop */
	}
	return abbrev ? `${city} (${abbrev})` : city;
}

export function formatWeekday(dateKey: string, tz: string): string {
	const d = new Date(`${dateKey}T12:00:00Z`);
	return new Intl.DateTimeFormat("en-US", {
		weekday: "long",
		timeZone: tz,
	}).format(d);
}

export function formatMonthDay(dateKey: string, tz: string): string {
	const d = new Date(`${dateKey}T12:00:00Z`);
	return new Intl.DateTimeFormat("en-US", {
		month: "short",
		day: "numeric",
		timeZone: tz,
	}).format(d);
}

export function formatTime(iso: string, tz: string): string {
	return new Intl.DateTimeFormat("en-US", {
		hour: "numeric",
		minute: "2-digit",
		timeZone: tz,
	}).format(new Date(iso));
}

export function ymd(iso: string, tz: string): string {
	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: tz,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	}).formatToParts(new Date(iso));
	const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
	return `${get("year")}-${get("month")}-${get("day")}`;
}
